import LocalizedStrings from 'localized-strings';

import { ScheduledBankTransferFrequency } from '__generated__/GQL';

import { ScheduledBankTransferEndDateDeterminedByOption } from './utils';

interface EndDateDeterminedByLocales {
  [ScheduledBankTransferEndDateDeterminedByOption.ExplicitDate]: string;
  [ScheduledBankTransferEndDateDeterminedByOption.Never]: string;
  [ScheduledBankTransferEndDateDeterminedByOption.NumberOfOccurrences]: {
    after: string;
    occurrence: string;
    occurrences: string;
  };
}

export const endDateDeterminedByLocales =
  new LocalizedStrings<EndDateDeterminedByLocales>({
    en: {
      EXPLICIT_DATE: 'On',
      NEVER: 'At revocation',
      NUMBER_OF_OCCURRENCES: {
        after: 'After',
        occurrence: 'occurrence',
        occurrences: 'occurrences',
      },
    },
    fr: {
      EXPLICIT_DATE: 'Le',
      NEVER: 'À annulation',
      NUMBER_OF_OCCURRENCES: {
        after: 'Après',
        occurrence: 'fois',
        occurrences: 'fois',
      },
    },
  } as const);

interface FrequencyLocales {
  [ScheduledBankTransferFrequency.EveryMonth]: string;
  [ScheduledBankTransferFrequency.EveryWeek]: string;
  [ScheduledBankTransferFrequency.EveryYear]: string;
  [ScheduledBankTransferFrequency.Once]: string;
}

export const frequencyLocales = new LocalizedStrings<FrequencyLocales>({
  en: {
    EVERY_MONTH: 'Every month',
    EVERY_WEEK: 'Every week',
    EVERY_YEAR: 'Every year',
    ONCE: 'Once',
  },
  fr: {
    EVERY_MONTH: 'Chaque mois',
    EVERY_WEEK: 'Chaque semaine',
    EVERY_YEAR: 'Chaque année',
    ONCE: 'Une fois',
  },
} as const);
